import { render } from "./Beertap.vue?vue&type=template&id=7e310a98"
import script from "./Beertap.vue?vue&type=script&lang=js"
export * from "./Beertap.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__